import { authenticatedApi } from "./api";

/**
 * Redirect helper for handling internal links
 * This helper can be used for banners, notifications, and other internal navigation
 *
 * @param {string} toType - The type of object (Session, Speaker, Sponsor, etc.)
 * @param {number} toId - The ID of the object
 * @param {string} eventSlug - The event slug
 * @param {Function} navigate - React Router navigate function
 * @returns {Promise<void>}
 */
export const redirectToInternalLink = async (
  toType,
  toId,
  eventSlug,
  navigate
) => {
  try {
    // Use fetchObjects to get the section information for the object
    const response = await authenticatedApi.fetchObjects(eventSlug, [
      {
        object_kind: toType,
        object_id: toId,
      },
    ]);

    // The response structure has objects grouped by type (sessions, speakers, etc.)
    const objectType = toType.toLowerCase() + "s"; // Convert "Session" to "sessions"
    const objects = response[objectType];

    if (objects && objects.length > 0) {
      const object = objects[0];

      // Get the section_id from the object
      const sectionId = object.section_id;

      if (sectionId) {
        // Navigate to the appropriate section page
        const path = `/e/${eventSlug}/sections/${sectionId}/${toId}`;
        navigate(path);
      } else {
      }
    } else {
    }
  } catch (error) {}
};

/**
 * Handle banner click - redirects to external URL or internal page
 *
 * @param {Object} banner - The banner object
 * @param {string} eventSlug - The event slug
 * @param {Function} navigate - React Router navigate function
 */
export const handleBannerClick = async (banner, eventSlug, navigate) => {
  if (banner.link_type === "external" && banner.external_url) {
    // Open external link in new tab
    window.open(banner.external_url, "_blank", "noopener,noreferrer");
  } else if (
    banner.link_type === "internal" &&
    banner.to_type &&
    banner.to_id
  ) {
    // Redirect to internal page
    await redirectToInternalLink(
      banner.to_type,
      banner.to_id,
      eventSlug,
      navigate
    );
  }
};
